import { useMutation, useQueryClient } from '@tanstack/react-query';

import { equipmentImagesListKey } from '@components/modals/EditSensorGalleryModal/services/useEquipmentImagesListQuery';

import { hardwareOverviewDetailsKey } from '@pages/HardwareOverviewDetails/services/useHardwareOverviewDetailsQuery';

import { apiClient } from '@services/apiClient';
import { installationPointPhotosKey } from '@services/useInstallationPointPhotosQuery';
import { listByInstPointKey } from '@services/useListByInstPointQuery';

const equipmentImageAttachFn = (data) => apiClient.post(`${APP_API_URL}equipment-image/attach`, data);

export const useEquipmentImageAttachMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: equipmentImageAttachFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [listByInstPointKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [hardwareOverviewDetailsKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [installationPointPhotosKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [equipmentImagesListKey()[0]] });
    },
  });
};
